import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import serviceData from "../../Data/serviceData";

const ServiceArea = () => {
  // State for managing the active tab (either "Pest Control" or "Cleaning")
  const [activeTab, setActiveTab] = useState("Cleaning");
  const [services, setServices] = useState([]);

  useEffect(() => {
    setServices(serviceData);
  }, []);

  // Filter services based on the selected category (tab)
  const filteredServices = services.filter(
    (service) => service.category === activeTab,
  );

  // Handle tab change
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Wrapper>
      <section className="overflow-hidden space" id="service-sec">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title6 justify-content-center">
              <span className="shape left">
                <span className="dots"></span>
              </span>
              OUR SERVICES
              <span className="shape right">
                <span className="dots"></span>
              </span>
            </span>
            <h2 className="sec-title">Explore The Best Services We Offer</h2>
          </div>

          <div
            className="nav nav-tabs service-tabs"
            id="nav-tab"
            role="tablist"
          >
            <button
              className={`nav-link th-btn ${
                activeTab === "Cleaning" ? "active" : ""
              }`}
              onClick={() => handleTabClick("Cleaning")}
              type="button"
            >
              Cleaning Service
            </button>
            <button
              className={`nav-link th-btn ${
                activeTab === "Pest Control" ? "active" : ""
              }`}
              onClick={() => handleTabClick("Pest Control")}
              type="button"
            >
              Pest Control Service
            </button>
          </div>

          <div className="row gy-4">
            {filteredServices.map((service) => (
              <div key={service.id} className="col-md-6 col-lg-4 mb-4">
                <div className="service-card style2 bg-shadow">
                  <div
                    className="service-card-bg-img"
                    style={{
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  <div className="service-content">
                    <div className="service-card-icon">
                      <img
                        src={service.icon}
                        alt="icon"
                        style={{
                          height: "60px",
                          width: "60px",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                    <h3 className="box-title">
                      <Link to="">{service.title}</Link>
                    </h3>
                    <div className="service-card-number">{service.number}</div>
                  </div>
                  <p
                    className="service-card-text text-justify"
                    style={{ textAlign: "justify" }}
                  >
                    {service.subTitle}
                  </p>
                  <Link
                    className="th-btn style10"
                    to={`/service/service-details/${service.id}`}
                  >
                    Read More <i className="fas fa-arrow-right ms-1"></i>
                  </Link>
                  <div className="service-card-shape">
                    <img
                      src="/assets/img/service/service-card-bg-2-1.png"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-md-6.col-lg-4 {
    display: flex;
  }

  .service-card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    height: 100%;
  }

  .service-content {
    flex-shrink: 0;
  }

  .service-card-text {
    flex-grow: 1;
    margin-bottom: 1rem;
  }

  .th-btn.style10 {
    margin-top: auto;
  }
`;

export default ServiceArea;
